import { Skeleton } from "src/component/Skeleton/Skeleton";

const MedicineAccordionSkeleton = () => (
    <div className="recurring-medicines-skeleton my-4">
        <div className="row my-4">
            {Array.from({ length: 3 }).map((_, key) => (
                <div
                    key={key}
                    className="col-sm-4 text-center font-size-14 m-auto d-flex flex-column align-items-center gap-1"
                >
                    <Skeleton variant="text" width="80px" height="16px" />
                    <Skeleton variant="text" width="60px" height="18px" />
                </div>
            ))}
        </div>

        {Array.from({ length: 2 }).map((_, key) => (
            <div key={key} className="col-sm-12 mb-3">
                <div className="medicine-accordion-header">
                    <div className="accordion-header-content">
                        <div className="accordion-header-left d-flex align-items-center gap-2">
                            <Skeleton variant="rounded" width={20} height={20} />
                            <Skeleton variant="text" width="40%" height={18} />
                        </div>
                        <div className="accordion-header-right d-flex align-items-center gap-3">
                            <div className="medicine-summary d-flex gap-3">
                                <div className="summary-item d-flex flex-column align-items-center gap-1">
                                    <Skeleton variant="text" width={60} height={12} />
                                    <Skeleton variant="text" width={40} height={14} />
                                </div>
                                <div className="summary-item d-flex flex-column align-items-center gap-1">
                                    <Skeleton variant="text" width={60} height={12} />
                                    <Skeleton variant="text" width={40} height={14} />
                                </div>
                            </div>
                            <Skeleton variant="rounded" width={36} height={36} />
                        </div>
                    </div>
                </div>
            </div>
        ))}
    </div>
)

export default MedicineAccordionSkeleton;